import {BrowserRouter, Routes,Route} from 'react-router-dom'
import WindowSizeContextProvider from './context/WindowSizeContext';
import Main from './page/main/Main';
import Overview1 from './page/overview1/Overview1';
import Overview2 from './page/overview2/Overview2';
import Overview3 from './page/overview3/Overview3';
import Overview4 from './page/overview4/Overview4';

function App() {
  return (
    <BrowserRouter>
     <WindowSizeContextProvider>
      <Routes>
       <Route path="/" element={<Main/>}/>
       <Route path='/project1' element={<Overview1/>}/>
       <Route path='/project2' element={<Overview2/>}/>
       <Route path='/project3' element={<Overview3/>}/>
       <Route path='/project4' element={<Overview4/>}/>
      </Routes>
     </WindowSizeContextProvider>
    </BrowserRouter>
  
  );
}

export default App;
